import { ReportHandler } from 'web-vitals';

// Suppress ResizeObserver errors in web-vitals
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args[0];
  if (
    errorMessage &&
    (typeof errorMessage === 'string' || errorMessage?.message) &&
    (String(errorMessage).includes('ResizeObserver loop') ||
     (errorMessage?.message && errorMessage.message.includes('ResizeObserver loop')))
  ) {
    return; // Suppress ResizeObserver errors
  }
  originalConsoleError.apply(console, args);
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;

